import { MapPin, Navigation } from "lucide-react";
import { COMPANY } from "../lib/constants";
import useReveal from "../hooks/useReveal";

export default function ServiceArea() {
  const head = useReveal();
  const map = useReveal();

  return (
    <section
      id="area"
      data-testid="service-area-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={head.ref}
          className={`fade-in-up ${head.visible ? "is-visible" : ""} max-w-2xl`}
        >
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#00B4D8]">
            Service Area
          </span>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] tracking-tight">
            Proudly serving Tampa Bay
          </h2>
          <p className="mt-4 text-base lg:text-lg text-slate-500">
            Based in {COMPANY.city} ({COMPANY.zip}). We cover Tampa, Brandon,
            St. Petersburg, Clearwater, and surrounding areas.
          </p>
        </div>

        <div
          ref={map.ref}
          className={`fade-in-up ${map.visible ? "is-visible" : ""} mt-10 relative rounded-3xl overflow-hidden border border-slate-200 shadow-[0_12px_40px_rgb(10,25,47,0.08)]`}
        >
          {/* Static (non-interactive) Google Maps embed */}
          <div className="relative aspect-[16/9] md:aspect-[21/9] bg-slate-100">
            <iframe
              data-testid="service-area-map"
              title="Service area map - Tampa Bay"
              src="https://www.google.com/maps?q=Tampa+Bay,+Florida&t=&z=10&ie=UTF8&iwloc=&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0 w-full h-full"
              style={{ border: 0, pointerEvents: "none" }}
              tabIndex={-1}
            />
            {/* Decorative pin overlay */}
            <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="relative">
                <div className="absolute -inset-6 rounded-full bg-[#00B4D8]/30 animate-ping" />
                <div className="relative w-12 h-12 rounded-full bg-[#00B4D8] flex items-center justify-center shadow-xl shadow-cyan-500/40 border-4 border-white">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
              </div>
            </div>
            {/* Bottom info overlay */}
            <div className="absolute bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-sm bg-white/95 backdrop-blur-md rounded-2xl p-4 sm:p-5 border border-slate-100 shadow-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-[#00B4D8]/10 flex items-center justify-center shrink-0">
                  <Navigation className="w-5 h-5 text-[#00B4D8]" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-[#0A192F]">
                    {COMPANY.name}
                  </p>
                  <p className="text-sm text-slate-500 mt-0.5">
                    {COMPANY.city} · ZIP {COMPANY.zip}
                  </p>
                  <p className="text-xs text-[#00B4D8] font-semibold mt-1">
                    Serving Tampa Bay area
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
